// test1295
(1295 && 0);
